import axios from 'axios'
import {
  AcceptedRunResponse,
  RunStatusResponse,
  StartRunResponse,
  SubmitSignaturesRequest,
} from '../models/types'

const apiUrl = process.env.REACT_APP_API_URL

const apiConfig = {
  serbiaInboundFetch: {
    baseUrl: `${apiUrl}/v3/serbia-inbound-fetch`,
  },
}

export async function startSerbianFetchRunV3(): Promise<StartRunResponse> {
  const { data } = await axios.post<StartRunResponse>(`${apiConfig.serbiaInboundFetch.baseUrl}/runs`)
  return data
}

export async function submitSerbianFetchSignaturesV3(runId: string, request: SubmitSignaturesRequest): Promise<AcceptedRunResponse> {
  const { data } = await axios.post<AcceptedRunResponse>(
    `${apiConfig.serbiaInboundFetch.baseUrl}/runs/${runId}/signatures`,
    request,
  )
  return data
}

export async function getSerbianFetchRunV3(runId: string): Promise<RunStatusResponse> {
  const { data } = await axios.get<RunStatusResponse>(`${apiConfig.serbiaInboundFetch.baseUrl}/runs/${runId}`)
  return data
}

export async function cancelSerbianFetchRunV3(runId: string): Promise<void> {
  await axios.delete(`${apiConfig.serbiaInboundFetch.baseUrl}/runs/${runId}`)
}
